import { render } from "./v-lead-details.vue?vue&type=template&id=846c65cc"
import script from "./v-lead-details.vue?vue&type=script&lang=js"
export * from "./v-lead-details.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__